import Beans3 from '@/beans';
import { i18n, riperStorage } from '@/base/helpers';
import Flow from './flow';

const icons = {
  referral: 'https://cdn.trybeans.com/static-v3/snow/emoji/referral.svg',
  discount: 'https://cdn.trybeans.com/static-v3/snow/emoji/discount.svg',
};

const Widget = {
  listen() {
    const { onAboutBamboo, onLogin, onRegister } = riperStorage;
    const snow = window.Beans3.Snow;
    snow.listen('snow:bamboo:about', onAboutBamboo);
    snow.listen('snow:bamboo:dashboard', onAboutBamboo);
    snow.listen('snow:bamboo:register', () => Flow.redirectOnAuthToProgramPage(onRegister));
    snow.listen('snow:bamboo:register', () => Flow.redirectOnAuthToProgramPage(onLogin));
    snow.listen('snow:bamboo:reward-copy', window.Beans3.Bamboo.Coupon.copyCoupon);
  },
  showMessageDefault() {
    Beans3.require('snow').then(function () {
      window.Beans3.Snow.toast({
        id: 'snow:bamboo:about',
        tagline: i18n.t('snow', 'refer_friend'),
        ctaEvent: 'snow:bamboo:about',
        icon: icons.referral,
      });
    });
  },
  showMessageReferralReward(coupon) {
    Beans3.require('snow').then(function () {
      const snow = window.Beans3.Snow;
      snow.toast({
        id: 'snow:bamboo:reward-copy',
        tagline: i18n.t('snow', 'copy_coupon', { coupon: coupon.coupon_code }),
        ctaEvent: 'snow:bamboo:reward-copy',
        icon: icons.discount,
      });
    });
  },
  init() {
    Widget.listen();
    Widget.showMessageDefault();
  },
};

export default Widget;
